module.exports = __webpack_public_path__ + "fonts/typicons.29f9630f.ttf";